import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { people } from "../../config/imagesLink";
import MessageInteraction from "./MessageInteraction";
import { useTranslation } from "react-i18next";
import { getChatUnreadCount } from "../../utils/chatReadUtils";
import { formatMessagePreviewText } from "../../utils/messageReplyUtils";

const ArchivedMessage = ({
  isShown,
  getChatList,
  archiveMessage,
  item,
  index,
  archiveActive,
  setArchiveActive,
  UserId,
  setMsgId,
  getArchivedList,
  getMessageList,
}) => {
  const { t } = useTranslation();

  const getUserImage = (image) =>
    !image || image === "" ? people.DefaultProfile : image;

  const handleImageError = (e) => {
    e.target.src = people.DefaultProfile;
  };

  const isBlockedByYou =
    item.chatInfo?.isBlockedByYou === true || item.isBlockedByYou === true;

  const unreadCount = getChatUnreadCount(item);
  const isCurrentChat =
    UserId &&
    UserId !== "All" &&
    String(item.chatInfo?.toUserUid) === String(UserId);
  const isActive = isCurrentChat || archiveActive === index;
  const showUnreadBadge = unreadCount > 0 && !isCurrentChat;
  const unreadBadgeLabel = unreadCount > 99 ? "99+" : unreadCount;

  const previewText = isBlockedByYou
    ? `${t("Newsfeed.Want to continue chat with this user")} ${t("Newsfeed.Unblock from settings")}`
    : formatMessagePreviewText(item.lastMsg || "");

  return (
    <Link
      to={`/Message/${item?.chatInfo?.toUserUid}`}
      className="message-list-link"
      onClick={() => {
        setArchiveActive(index);
        setMsgId(item.chatInfo.msgID);
      }}
    >
      <div className={`${isShown ? "d-block" : "d-md-block d-none"} message-list-item`}>
        <div
          className={`${isActive ? "activeMsg" : ""} message-cards d-flex align-items-center`}
        >
          <div className="msg-list-avatar-wrap me-3 ms-1">
            <img
              src={getUserImage(item.chatInfo?.toUserImage)}
              onError={handleImageError}
              alt={item.chatInfo?.toUserFullName || ""}
            />
          </div>

          <div className="msg-content flex-grow-1 me-1">
            <div className="name-time d-flex justify-content-between align-items-center gap-2">
              <div className="message-user-name darkmode f-12 f-600">
                {item.chatInfo?.toUserFullName}
              </div>
              <div
                className={`message-time darkmode f-10 f-400 flex-shrink-0 ${
                  showUnreadBadge ? "message-time-unread" : ""
                }`}
              >
                {moment.utc(item.lastMsgTime).local().format("LT")}
              </div>
            </div>

            <div className="msg-preview-row">
              <div
                className={`msg-preview-text ${
                  item.lastMsgIsRead === false && !isCurrentChat ? "fw-bolder" : ""
                }`}
              >
                <p className="messageText darkmode f-10">{previewText}</p>
              </div>

              <div className="msg-preview-meta">
                {showUnreadBadge ? (
                  <span
                    className={`msg-unread-badge ${
                      unreadCount > 9 ? "msg-unread-badge-wide" : ""
                    }`}
                  >
                    {unreadBadgeLabel}
                  </span>
                ) : null}
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <MessageInteraction
                    chatId={item.chatID}
                    isRead={item.lastMsgIsRead}
                    isPined={item.isPined}
                    getChatList={getChatList}
                    archiveMessage={archiveMessage}
                    msgId={item.chatInfo.msgID}
                    usermsgId={item.chatInfo.msgID}
                    UserId={item.chatInfo.toUserUid}
                    toUserUId={item.chatInfo.toUserUid}
                    getArchivedList={getArchivedList}
                    getMessageList={getMessageList}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ArchivedMessage;
